<template>
  <div>
    <div v-if="nowPage == 1" class="certificateListBox acea-row">
      <viewer
        style="width: 27%; margin: 30px"
        v-for="(itemT, index) in tempLest"
        :key="index"
      >
        <img :src="itemT.src" class="imagetwo" />
      </viewer>
    </div>
    <a-list
      item-layout="vertical"
      size="large"
      :pagination="pagination"
      :data-source="certificateList"
    >
      <a-list-item slot="renderItem" key="item.scr" slot-scope="item">
        <div class="certificateListBox acea-row">
          <viewer
            style="width: 23%; margin: 30px"
            v-for="(itemT, index) in item.list"
            :key="index"
          >
            <img :src="itemT.src" class="image" />
          </viewer>
        </div>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pagination: {
        onChange: (page) => {
          console.log(page, "ff");
          this.nowPage = page;
        },
        pageSize: 1,
      },
      nowPage: 1,
      tempLest: [
        {
          src: require("@/assets/about_company/qualifications/qualifications_row_1.png"),
        },
        {
          src: require("@/assets/about_company/qualifications/qualifications_row_2.png"),
        },
      ],
      certificateList: [
        {
          list: [
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_3.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_4.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_5.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_6.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_7.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_8.png"),
            },
          ],
        },
        {
          list: [
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_9.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_10.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_11.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_12.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_13.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_14.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_15.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_16.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_17.png"),
            },
          ],
        },
        {
          list: [
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_18.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_19.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_20.png"),
            },
            {
              src: require("@/assets/about_company/qualifications/qualifications_row_21.png"),
            },
          ],
        },
      ],
    };
  },
};
</script>
<style scoped>
.certificateListBox {
  width: 1400px;
  justify-content: center;
}
.certificateListBox .image {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* width: 23%; */
  height: 400px;
  /* margin: 30px; */
}
.certificateListBox .imagetwo {
  background-size: 100% 100%;
  background-repeat: no-repeat;
  /* width: 35%; */
  height: 300px;
  /* margin: 30px; */
}

@media screen and (max-width: 850px) {
  .certificateListBox {
    width: 600px;
  }
  .certificateListBox .image {
    height: 210px;
  }
  .certificateListBox .imagetwo {
    height: 160px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutCompany/certificate.vue